module.exports = __webpack_public_path__ + "img/gift.23ff7203.gif";